import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { MonitoramentoDecisoesService } from '../../../../providers/monitoramento-decisoes-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';

import { ModalEditarTextoPage } from '../../../modais/modal-editar-texto/modal-editar-texto';
import { ModalDeterminacoesEvidenciasPage } from '../../../modais/modal-determinacoes-evidencias/modal-determinacoes-evidencias';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { ModulosController } from '../../modulos-controller';

import { ModalArquivosPage } from '../../../modais/modal-arquivos/modal-arquivos';

declare var jsPDF: any;

@Component({
    selector: 'page-determinacoes',
    templateUrl: 'determinacoes.html',
    providers: [
        MonitoramentoDecisoesService
    ]
})
export class MonitoramentoDecisoesPage extends ModulosController {
    abaTipoMonitoramento: any;
    abaTipoMonitoramentoHistorico: any;
    listaDados: any = [];
    listaDadosDeterminacao: any = [];
    listaDadosRecomendacao: any = [];
    listaDadosHistorico: any = [];
    listaDadosHistoricoDeterminacao: any = [];
    listaDadosHistoricoRecomendacao: any = [];
    listaArquivos: any = [];
    loading: boolean = true;
    loadingHistorico: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "71";
    // isJurisdicionado: any;
    TIPO_DETERMINACAO: string = "1";
    TIPO_RECOMENDACAO: string = "2";
    analiseDeterminacao: any;
    codigoModulo: any;

    page1: number = 1;

    order1: string = 'numeroProcesso';
    reverse1: boolean = true;

    page2: number = 1;

    order2: string = 'numeroProcesso';
    reverse2: boolean = true;

    page3: number = 1;

    order3: string = 'numeroProcesso';
    reverse3: boolean = true;

    page4: number = 1;

    order4: string = 'numeroProcesso';
    reverse4: boolean = true;

    page5: number = 1;

    order5: string = 'numeroProcesso';
    reverse5: boolean = true;

    page6: number = 1;

    order6: string = 'numeroProcesso';
    reverse6: boolean = true;

    filter: any = { exercicio: '', processo: '', acordao: '', descricao: '' };

    analise: any = null;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public navParams: NavParams,
        public monitoramentoDecisoesService: MonitoramentoDecisoesService,
        public gestaoPcaService: GestaoPcaService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        private menuService: MenuService) {

        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.abaTipoMonitoramento = 'determinacao';
        this.abaTipoMonitoramentoHistorico = 'determinacao';

        this.codigoModulo = this.navParams.get('analise').idModuloPca;

        this.setModuloId(10);

        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
        // this.isJurisdicionado = this.usuarioService.isJurisdicionado();
        this.carregarDados();
    }

    setOrder1(value: string) {
        if (this.order1 === value) {
            this.reverse1 = false;
            this.order1 = "-" + value;
        } else {
            this.reverse1 = true;
            this.order1 = value;
        }
    }

    setOrder2(value: string) {
        if (this.order2 === value) {
            this.reverse2 = false;
            this.order2 = "-" + value;
        } else {
            this.reverse2 = true;
            this.order2 = value;
        }
    }

    setOrder3(value: string) {
        if (this.order3 === value) {
            this.reverse3 = false;
            this.order3 = "-" + value;
        } else {
            this.reverse3 = true;
            this.order3 = value;
        }
    }

    setOrder4(value: string) {
        if (this.order4 === value) {
            this.reverse4 = false;
            this.order4 = "-" + value;
        } else {
            this.reverse4 = true;
            this.order4 = value;
        }
    }

    setOrder5(value: string) {
        if (this.order5 === value) {
            this.reverse5 = false;
            this.order5 = "-" + value;
        } else {
            this.reverse5 = true;
            this.order5 = value;
        }
    }

    setOrder6(value: string) {
        if (this.order6 === value) {
            this.reverse6 = false;
            this.order6 = "-" + value;
        } else {
            this.reverse6 = true;
            this.order6 = value;
        }
    }



    carregarDados() {
        this.loading = true;

        if (this.isJurisdicionado) {
            // this.carregarAnalise(); Utilizado pra validar status da análise e bloquear campos

            this.monitoramentoDecisoesService.obterDeterminacoesJur().subscribe(data => {
                this.listaDados = data;

                if (this.listaDados != undefined && this.listaDados.lstMonitoramentoDecisoes != undefined && this.listaDados.lstMonitoramentoDecisoes.length > 0) {
                    this.listaDadosDeterminacao = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_DETERMINACAO);
                    this.listaDadosRecomendacao = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_RECOMENDACAO);
                }

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            });
        } else {
            this.monitoramentoDecisoesService.obterDeterminacoes().subscribe(data => {
                this.listaDados = data;

                if (this.listaDados != undefined && this.listaDados.lstMonitoramentoDecisoes != undefined && this.listaDados.lstMonitoramentoDecisoes.length > 0) {
                    this.listaDadosDeterminacao = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_DETERMINACAO);
                    this.listaDadosRecomendacao = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_RECOMENDACAO);
                }

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            });

            this.monitoramentoDecisoesService.obterDeterminacoesHistoricas().subscribe(data => {
                this.listaDadosHistorico = data;

                if (this.listaDadosHistorico != undefined && this.listaDadosHistorico != undefined && this.listaDadosHistorico.length > 0) {
                    this.listaDadosHistoricoDeterminacao = this.listaDadosHistorico.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_DETERMINACAO);
                    this.listaDadosHistoricoRecomendacao = this.listaDadosHistorico.filter((determinacao) => determinacao.tipoDeterminacao == this.TIPO_RECOMENDACAO);
                }

                this.loadingHistorico = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            });
        }
    }

    carregarAnalise() {
        // this.monitoramentoDecisoesService.obterListaAnalises(this.monitoramentoDecisoesService.codigoModuloMonitoramentoDecisoes).subscribe(data => {
        //     this.analiseDeterminacao = data != null && data.length > 0 ? data[0] : null;
        // }, error => {
        //     console.log("erro: " + error);
        // });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaMonitoramentoDecisoes() {
        this.menuService.redirecionarPagina(this.monitoramentoDecisoesService.obterIdPaginaMonitoramentoDecisoes());
    }

    apresentaModal(titulo: String, modalPage: any) {
        let modal = this.modalCtrl.create(modalPage,
            {
                param1: titulo,
                jurisdicionado: this.isJurisdicionado
            });
        modal.onDidDismiss(retornoModal => {

        });
        modal.present();
    }

    addComentario() {
        // this.apresentaModal("Adicionar Comentário", ModalDeterminacoesComentarioPage);
    }

    visualizarEvidencias(item) {

        let titulo = "Evidências";

        let modal = this.modalCtrl.create(ModalDeterminacoesEvidenciasPage,
            {
                titulo: titulo,
                IdProcesso: this.hashcode(item.descricao + item.numeroProcesso + item.numeroAcordao + this.PCAAtiva.id),
                idModuloPCA: this.codigoModulo,
                tipoAnalise: '0',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Processo: " + item.numeroProcesso,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                determinacao: item
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    enviarEvidencia(determinacao) {
        this.monitoramentoDecisoesService.salvarDeterminacoes(this.listaDados).subscribe(data => {
            let modal = this.modalCtrl.create(ModalDeterminacoesEvidenciasPage,
                {
                    isJurisdicionado: this.isJurisdicionado,
                    determinacao: determinacao
                });
            modal.onDidDismiss(retornoModal => {
                this.carregarDados();
            });
            modal.present();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao abrir o envio de evidências:" + error);
        })
    }

    hashcode(obj) {
        var hash = 0;
        for (var i = 0; i < obj.length; i++) {
            var character = obj.charCodeAt(i);
            hash = ((hash << 5) - hash) + character;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    abrirListarArquivo(item) {
        let titulo = "Evidências";
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                // IdProcesso: encode().value(item.descricao),
                IdProcesso: this.hashcode(item.descricao + item.numeroProcesso + item.numeroAcordao + this.PCAAtiva.id),
                idModuloPCA: this.codigoModulo,
                tipoAnalise: '0',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Processo: " + item.numeroProcesso,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    salvarImportacaoDeterminacoes() {
        this.monitoramentoDecisoesService.salvarDeterminacoesJur(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error.mensagem);
        });
    }

    finalizarDeterminacoes() {
        if (this.listaDados) {
            if (this.validarComentarios()) {
                this.monitoramentoDecisoesService.salvarDeterminacoesJur(this.listaDados).subscribe(data => {

                    this.monitoramentoDecisoesService.obterDeterminacoesJur().subscribe(dataMon => {

                        this.monitoramentoDecisoesService.finalizarDeterminacoes(dataMon).subscribe(data => {
                            this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                            this.voltarParaMonitoramentoDecisoes();
                        }, error => {
                            this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error.mensagem);
                        });

                    }, error => {
                        console.log("erro: " + error.error.mensagem);
                        this.loading = false;
                    });

                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar para finalizar:" + error.mensagem);
                });
            }
            else {
                this.alertService.mostraAlerta('', 'É necessário inserir o comentário para todas as determinações/recomendações que não possuem evidências.');
            }
        } else {
            this.monitoramentoDecisoesService.finalizarDeterminacoes(null).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaMonitoramentoDecisoes();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error.mensagem);
            });
        }
    }

    validarComentarios() {
        let ehValido = true;

        this.listaDados.lstMonitoramentoDecisoes.forEach(item => {

            if (item.comentario.toString().trim() == '' && !item.temArquivo) {
                ehValido = false;
            }
        });

        return ehValido;
    }

    editarParecer(item) {
        let modal = this.modalCtrl.create(ModalEditarTextoPage, { texto: item.parecer, parecer: true, analise: this.analise });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal) {
                if (retornoModal.salvar) {
                    item.parecer = retornoModal.texto;
                }
            }
        });
        modal.present();
    }

    editarComentario(item) {
        let modal = this.modalCtrl.create(ModalEditarTextoPage, { texto: item.comentario, parecer: true, analise: this.analise });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.salvar) {
                item.comentario = retornoModal.texto;
            }
        });
        modal.present();
    }

    salvarFlagIncluir() {

        this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);

        this.monitoramentoDecisoesService.salvarDeterminacoes(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";
        let verifica = true;

        this.listaDados.lstMonitoramentoDecisoes.forEach(item => {
            if (item.parecer.replace(/^\s+|\s+$/g, '') == "" || item.parecer == null || item.parecer == undefined || !item.parecer) {
                verifica = false;
            }
        });


        if ((this.listaDados.dsResultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResultadoAnalise == null || this.listaDados.dsResultadoAnalise == undefined || !this.listaDados.dsResultadoAnalise) && !verifica) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório. Necessário preencher ou o Parecer Geral ou TODOS os pareceres individuais.");
        } else {
            if (this.listaDados) {

                this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);

                idAnalise = this.listaDados.idModuloAnalise;

                this.monitoramentoDecisoesService.salvarDeterminacoes(this.listaDados).subscribe(data => {
                    this.monitoramentoDecisoesService.submeterCertificado(this.listaDados).subscribe(data => {
                        this.alertService.mostraAlerta("", "Submetido com sucesso.");
                        this.voltarParaMonitoramentoDecisoes();
                    }, error => {
                        this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    });
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                });
            }
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    onBaixaChange(item) {
        if (item.flBaixa) {
            if (!item.flReincidencia) {
                item.flCertificado = true;
            }
        } else {
            if (!item.flReincidencia) {
                item.flCertificado = false;
            }
        }
    }

    onReincidenciaChange(item) {
        if (item.flReincidencia) {
            if (!item.flBaixa) {
                item.flCertificado = true;
            }
        } else {
            if (!item.flBaixa) {
                item.flCertificado = false;
            }
        }
    }

    onIncluirChange(item) {

        if (item.flBaixa) {
            item.flBaixa = item.flCertificado;
        }

        if (item.flReincidencia) {
            item.flReincidencia = item.flCertificado;
        }
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Determinações Expedidas - Exercício Atual", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Processo", dataKey: "processo" },
            { title: "Acórdão", dataKey: "acordao" },
            { title: "Exercício", dataKey: "exercicio" },
            { title: "Descrição", dataKey: "desc" },
            { title: "Comentário", dataKey: "comentario" },
            { title: "Evidência Enviada?", dataKey: "evidencia" }
        ];

        let rows = [];

        let lista = this.abaTipoMonitoramento == "determinacao" ? this.listaDadosDeterminacao : this.listaDadosRecomendacao;

        lista.forEach(contrato => {

            var item = {
                "processo": contrato.numeroProcesso,
                "acordao": contrato.numeroAcordao,
                "exercicio": contrato.exercicio,
                "desc": contrato.descricao,
                "comentario": contrato.comentario,
                "evidencia": contrato.temArquivo ? "Sim" : "Não"
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'wrap',
                fontSize: 8
            },
            columnStyles: {
                text: { columnWidth: 'auto' },
                processo: { columnWidth: 25 },
                acordao: { columnWidth: 25 },
                exercicio: { columnWidth: 25 },
                desc: { columnWidth: 93 },
                comentario: { columnWidth: 93 },
                evidencia: { columnWidth: 25 }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save(this.abaTipoMonitoramento + '.pdf');
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/monitoramento-decisoes/determinacoes/determinacoes.ts